import { render, staticRenderFns } from "./BadgeList.vue?vue&type=template&id=7cda3b20&scoped=true&"
import script from "./BadgeList.vue?vue&type=script&lang=js&"
export * from "./BadgeList.vue?vue&type=script&lang=js&"
import style0 from "./BadgeList.vue?vue&type=style&index=0&id=7cda3b20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cda3b20",
  null
  
)

export default component.exports